<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Jugadas"   />

    <Plays />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import Plays from "@/components/Pages/Admin/Plays/index.vue";

export default defineComponent({
  name: "PlaysPage",
  components: {
    PageTitle,
    Plays,
  },
});
</script>
